import { WEDDING_COURSE_ID } from './routes'

/**
 * Показывать ли кнопку «Скачать рецепт» (ссылку на PDF).
 *
 * Кнопку убрали из библиотеки и из всех курсов, кроме свадебного: файлы с
 * рецептами раздаются только его ученикам. Решение держим одной функцией, а не
 * условиями по экранам, — когда правило поменяется, править нужно будет здесь.
 *
 * `courseId` — курс, внутри которого открыт рецепт. `null` или `undefined`
 * значит, что рецепт открыт сам по себе, карточкой библиотеки.
 */
export const canDownloadRecipeFile = (
  courseId: number | null | undefined
): boolean => courseId === WEDDING_COURSE_ID
